/**
 * 生成唯一文件名，避免 OSS 覆盖
 * @param {string} originalFileName
 * @returns {string}
 */
export const generateUniqueFileName = originalFileName => {
  const timestamp = Date.now()
  const randomNum = Math.floor(Math.random() * 10000)
  const fileExtension = originalFileName.substring(
    originalFileName.lastIndexOf('.')
  )
  return `${timestamp}_${randomNum}${fileExtension}`
}
